/**
 * PiattoProntoNotifier
 * ====================
 * Listener globale: quando il KDS preme EVASA su una comanda, il backend invia
 * via WebSocket l'evento `piatto_pronto` MIRATO al cameriere che aveva fatto
 * l'ordine (`waiter_id`). Questo componente:
 *  - Riproduce un dingDong + parla "Piatto da ritirare: [items] [tavolo]"
 *    (Web Speech API italiana)
 *  - Mostra un toast persistente 8s con il dettaglio
 *
 * Montato nel Layout principale → attivo su tutte le pagine del cameriere
 * (Mappa Sala, Terminale Cassa, Order Editor, ecc.) — così il cameriere riceve
 * l'avviso ovunque sia il suo tablet.
 */
import { useEffect } from "react";
import { useWS } from "@/contexts/WebSocketContext";
import { speakPiattoPronto } from "@/lib/audioAlerts";
import { toast } from "sonner";
import { Hand } from "lucide-react";

const PiattoProntoNotifier = () => {
    const { subscribe } = useWS() || {};

    useEffect(() => {
        if (!subscribe) return;
        const unsub = subscribe((msg) => {
            if (msg?.type !== "piatto_pronto") return;
            const items = Array.isArray(msg.items) ? msg.items : [];
            const tableLabel = msg.table_label || "";
            // Notifica audio + voce
            speakPiattoPronto(items, tableLabel);
            // Toast visivo persistente
            const itemsTxt = items.length > 0 ? items.join(", ") : "comanda";
            toast.success(
                `Piatto da ritirare: ${itemsTxt}`,
                {
                    description: tableLabel ? `📍 ${tableLabel}` : undefined,
                    duration: 8000,
                    icon: <Hand className="w-5 h-5 text-emerald-400" />,
                    id: `piatto-pronto-${msg.order_id || Date.now()}`,
                }
            );
        });
        return unsub;
    }, [subscribe]);

    return null;
};

export default PiattoProntoNotifier;
